<template>
    <div>
        <strong>{{ $_.get(activity, "actor") }}</strong> :
        <strong>{{ $_.get(activity, "payload.channelName") }}</strong> {{ $t("auto.stateChangedFrom") }}
        <strong>{{ $_.get(activity, "payload.oldState") }}</strong> {{ $t("auto.to") }}
        <strong>{{ $_.get(activity, "payload.newState") }}</strong>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "WhatsappV1BotStateChanged",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>
<style scoped lang="scss"></style>
